import React from 'react';
import './App.scss';

import { getTemtemNumber } from "./helpers";
import DetailedTechnique from "./components/DetailedTechnique";

class App extends React.Component {

  constructor() {
    super();
    const baseURL = document.getElementById("base-url") ? document.getElementById("base-url").getAttribute("data-url") : ""; // Grab the Base URL for data
    const baseImgURL = document.getElementById("base-url") ? document.getElementById("base-url").getAttribute("data-image-url") : ""; // Grab the Base URL for data
    this.state = {
      baseURL,
      baseImgURL,
      temtems: [],
      navOpen: false,
      selectedTemtem: null,
      highlightTechniques: [],
    };
    this.fetchTemtem();
  }

  fetchTemtem = () => {
    // fetch Temtem information
    fetch(this.state.baseURL + "/api/v1/temtems?include=techniques")
    .then((response) => response.json())
    .then((json) => {
      let temtems = json.data.temtems;
      this.setState({
        temtems,
      });
    });
  }

  onTemtemSelect = (index) => {
    const  { temtems }  = this.state;

    const selectedTemtem = temtems[index];

    window.scrollTo(0,0);

    this.setState({
      selectedTemtem,
      highlightTechniques: [],
    });
  }

  onRemoveSelect = () => {
    this.setState({
      selectedTemtem: null,
      highlightTechniques: [],
    });
  }

  onToggleHighlight = (name) => {
    let { highlightTechniques } = this.state;

    if (highlightTechniques.includes(name)) {
      highlightTechniques.splice(highlightTechniques.indexOf(name), 1);
    } else {
      highlightTechniques.push(name);
    }

    this.setState({
      highlightTechniques,
    });
  }

  onToggleNav = () => {
    const { navOpen } = this.state;

    this.setState({
      navOpen: !navOpen,
    });
  }

  render() {
    const { selectedTemtem } = this.state;
    let temtemNumber;
    if (selectedTemtem) {
      temtemNumber = getTemtemNumber(selectedTemtem);
    }

    return (
      <div className="App">
        <div className="selected-temtem">
          <div className="temtem-info">
            <div className="portrait">
              { selectedTemtem ? (
                <img src={`${this.state.baseImgURL}/temtem/regular/${temtemNumber}.png`} alt="temtem name" onClick={this.onRemoveSelect}/>

              ) : (
                <div className="empty"> ? </div>
              )}
            </div>
            { selectedTemtem ? (
              <div className="details">
                <div className="name">
                  <span>#{temtemNumber}</span>
                  {selectedTemtem.name}
                </div>
                <div className="types">
                  {selectedTemtem.types.map((type, key) => <i key={key} className={`type ${type.toLowerCase()}`} />)}
                </div>
              </div>
            ) : (
              <div className="details">
                <div className="name">
                  Select Temtem
                </div>
              </div>
            )}
          </div>
          { selectedTemtem ? (
            <div className="egg-techniques">
              <h3>Egg Techniques</h3>
              <div className="techniques">
                {
                  selectedTemtem.techniques && selectedTemtem.techniques.egg ?
                    selectedTemtem.techniques.egg.map((technique) => (
                      <DetailedTechnique
                      baseImgURL={this.state.baseImgURL}
                      technique={technique.technique}
                      className={`${this.state.highlightTechniques.includes(technique.technique.name) ? " highlight" : ""}`}
                      onClick={() => this.onToggleHighlight(technique.technique.name)} />
                    )
                  ) : (
                    `${selectedTemtem.name} does not have any Egg Techniques`
                  )}
              </div>
            </div>
          ) : (
            <div className="select-temtem">
              <h3>Available Temtem</h3>
              <div className="temtem-list">
                {this.state.temtems.map((temtem, index) => temtem.is_obtainable ? (
                  <div className="temtem" onClick={() => this.onTemtemSelect(index)}>
                    <div className="details">
                      <div className="portrait">
                        <img src={`${this.state.baseImgURL}/temtem/regular/${getTemtemNumber(temtem)}.png`} alt="temtem name"/>
                      </div>
                      <div className="info">
                        <div className="name">
                          <span>#{getTemtemNumber(temtem)}</span>
                          {temtem.name}
                        </div>
                        <div className="types">
                          {temtem.types.map((type, key) => <i key={key} className={`type ${type.toLowerCase()}`} />)}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null)}
              </div>
            </div>
          )}
        </div>
        { selectedTemtem ? (
          <div className="parent-list">
            <h2>Possible Parents</h2>
            {
              this.state.temtems.map((temtem, index) => {
                if (Array.isArray(temtem.types) && selectedTemtem.types.some((t) => temtem.types.includes(t)) && temtem.name !== selectedTemtem.name && temtem.is_obtainable) {
                  const techniques = temtem.techniques ? [].concat(temtem.techniques.level_up, temtem.techniques.training_course, temtem.techniques.egg).filter((t) =>  {
                    if (selectedTemtem.techniques && selectedTemtem.techniques.egg) {
                      return !!selectedTemtem.techniques.egg.find((et) => et && t ? et.technique.name === t.technique.name : false);
                    }
                    return null;
                  }) : [];
                  return (
                    <div className="parent-temtem">
                      <div className="details">
                        <div className="portrait">
                          <img src={`${this.state.baseImgURL}/temtem/regular/${getTemtemNumber(temtem)}.png`} alt="temtem name" onClick={() => this.onTemtemSelect(index)}/>
                        </div>
                        <div className="info">
                          <div className="name">
                            <span>#{getTemtemNumber(temtem)}</span>
                            {temtem.name}
                          </div>
                          <div className="types">
                            {temtem.types.map((type, key) => <i key={key} className={`type ${type.toLowerCase()}`} />)}
                          </div>
                        </div>
                      </div>
                      <div className="techniques">
                        {techniques.map((t, i) => <div className={`technique ${t.technique.type.toLowerCase()}${this.state.highlightTechniques.includes(t.technique.name) ? " highlight" : ""}`} key={i}>{t.technique.name}</div>)}
                      </div>
                    </div>
                  );
                }
                return null;
              })
            }
          </div>
        ): null}
      </div>
    );
  }
}

export default App;
